import React from 'react';
import { Snackbar, Dialog, Tooltip, Button, Box } from '@mui/material';
import DataGrid from '../../Component/DataGrid/DataGrid';
import { TableColumn } from 'react-data-table-component';
import { ShowAlert } from '../../Component/ShowAlert';
import FxAllocationService from '../../Services/FxAllocationService';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import './FxPoolsMainPage.css';
import { ColumnsFXPoolDetails, IFXPoolDetails } from '../FXReports/Interface';
import { Actions, clearLocalStorage, getColumnsFXPoolDetails, getRequestDataForReportsWithDateAndPage, ReportsCommon, ReportsStateCommon, getLast30DaysRange } from '../../Component/Reusables/Utility';
import { FXDashboardPageProps, FXDashboardPageState } from './Interface';
import UserAndPermissionService from '../../Services/UserAndPermissionService';
import { fxAllocationPermissions } from '../../Component/Permissions/PermissionsInterface.';
import { SyncContext, SyncContextType } from '../../Contexts/BatchSyncContext';
import { ISelectedDateRangeString } from '../../Component/DataGrid/Interface';
import FxPurchaseDetails from './FxPurchaseDetail/FxPurchaseDetail';
import CustomMaterialMenu from '../../Component/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import ReusableDrawer from '../../Component/RightDrawer/ReusableDrawer';
import FilterAltSharpIcon from '@mui/icons-material/FilterAltSharp';
import Badge from '@mui/material/Badge';
import { fetchRecipientCountryList } from '../../Component/Reusables/Recipient';
import moment from 'moment';

class FxPoolsMainPage extends React.Component<FXDashboardPageProps, FXDashboardPageState> {
    static contextType = SyncContext;
    private _context!: SyncContextType;
    public tableColumns: TableColumn<IFXPoolDetails>[];

    constructor(props_: FXDashboardPageProps) {
        super(props_);
        let monthRange = getLast30DaysRange();
        this.state = {
            accessToken: "",
            countryId: "",
            dashboardWidget: [
                {
                    title: "Total Active FX Inventory",
                    value: "",
                    icon: "account_balance_wallet",
                    trend: "",
                    subtextKey: "totalActiveFXInventorys",
                    key: "totalActiveFXInventoryCount"
                },
                {
                    title: "Active Allocations",
                    value: "",
                    subtext: "",
                    icon: "pool",
                    subtextKey: "activeAllocations",
                    key: "activeAllocationCount"
                },
                {
                    title: "Recent Transactions",
                    value: "",
                    icon: "history",
                    subtext: "",
                    subtextKey: "lastTransactionTime",
                    key: "recentTransactionCount"
                }
            ],
            currentRowsPerPage: 10,
            currentPage: 1,
            paginationReset: false,
            totalRows: 100,
            searchText: "",
            userId: '',
            data: [],
            snackbarOpen: false,
            snackbarMessage: '',
            showPurchaseDetails: false,
            selectedPool: null,
            selectedDateRange: {
                startDate: monthRange.startDate,
                endDate: monthRange.endDate,
            },
            isDrawerOpen: false,
            appliedFiltersCount: 1
        }
        const listColumnsToHide = [
            ColumnsFXPoolDetails.liquidityPartnerId,
            ColumnsFXPoolDetails.settlementDate,
            ColumnsFXPoolDetails.usdCurrencyRate,
            ColumnsFXPoolDetails.fromCurrencyRate,
            ColumnsFXPoolDetails.toCurrencyRate,
            ColumnsFXPoolDetails.currencySpent,
            ColumnsFXPoolDetails.amountSpent,
            ColumnsFXPoolDetails.currencyObtained,
            ColumnsFXPoolDetails.amountObtained,
            ColumnsFXPoolDetails.targetCountryCorridor,
            ColumnsFXPoolDetails.totalAllocatedAmount,
            ColumnsFXPoolDetails.totalReversedAmount,
            ColumnsFXPoolDetails.fromCurrencySymbol,
            ColumnsFXPoolDetails.toCurrencySymbol,
            ColumnsFXPoolDetails.liquidityPartner,
            ColumnsFXPoolDetails.proofOfPurchaseLocation
        ];
        const listColumnsToExcludeFromExport = [
            ColumnsFXPoolDetails.proofOfPurchaseLocation
        ];
        this.tableColumns = getColumnsFXPoolDetails(listColumnsToHide, listColumnsToExcludeFromExport);
        this.tableColumns.push({
            name: 'Actions',
            cell: row => {
                const popoverItems = [
                    { key: Actions.View, label: "Details" },
                    { key: Actions.Edit, label: "Edit" }
                ];

                if (row.totalAllocatedAmount === '0.00') {
                    popoverItems.push({ key: Actions.Delete, label: "Delete" });
                }
                return (
                    <CustomMaterialMenu
                        fontSize="small"
                        multiPopoverItems={popoverItems}
                        onPopoverClick={(key_: string) => {
                            if (key_ === Actions.Edit) {
                                this.handleViewDetails(row, key_);
                            } else if (key_ === Actions.View) {
                                this.handleViewDetails(row, key_);
                            } else if (key_ === Actions.Delete) {
                                this.handleDeletePurchase(row);
                            }
                        }}
                        disabled={false}
                    />
                );
            },
            allowOverflow: true,
            button: true,
            width: '100px'
        });

    }
    public async componentDidMount() {
        try {
            //Yet to add permission for FX report page

            const _accessToken = await loadFromLocalStorage('accessToken');
            const _profile = await loadFromLocalStorage('profile');

            if (!_accessToken || !_profile) {
                clearLocalStorage();
                return;
            }
            const accessToken = _accessToken.toString();
            const userProfile = typeof _profile === 'string' ? JSON.parse(_profile) : _profile;


            this.setState({ accessToken }, async () => {
                try {
                    /*if (userProfile?.roleId) {
                        const permissionResponseRaw = await UserAndPermissionService.getPermissions(accessToken, userProfile?.roleId);
                        const permissionResponse = await permissionResponseRaw.json();

                        if (!permissionResponse?.permissions?.fxAllocation?.isVisible) {
                            clearLocalStorage();
                            return;
                        }

                        const permissions = permissionResponse.permissions

                        this._context.dispatch({
                            type: "SET_PERMISSION", payload: {
                                permissions
                            },
                        });

                        const settings = permissionResponse.permissions.fxReports;
                        let fxSettings: fxAllocationPermissions = {
                            isVisible: settings.isVisible,
                        };

                        this.setState({ fxSettings }, () => {
                            this.fetchReportData()
                        });

                    } else {
                        this.fetchReportData()
                    }*/
                    this.fetchReportData();
                } catch (error) {
                    console.error("Error fetching permissions:", error);
                }
            });

        } catch (error) {
            console.error("Error in componentDidMount:", error);
            clearLocalStorage();
        }
    }

    public fetchReportData = async () => {
        try {
            FxAllocationService.getFxPurchaseList(this.state.accessToken, getRequestDataForReportsWithDateAndPage(this.state)).then(response => {
                if (response.ok) {
                    response.json().then(resp => {
                        this.setState({
                            data: resp.data,
                            totalRows: resp.totalRecords
                        })
                    });
                }
                else {
                    throw new Error('Failed to load data');
                }
            });
            await this.fetchDashboardData();
        } catch (error) {
            ShowAlert("Error", "Failed to load FX allocation data", "error");
        }
    };

    public getDashboardRequest = async (state: ReportsStateCommon) => {
        let monthRange = getLast30DaysRange();
        const startDate = state.selectedDateRange.startDate === '' ? monthRange.startDate : state.selectedDateRange.startDate;
        const endDate = state.selectedDateRange.endDate === '' ? monthRange.endDate : state.selectedDateRange.endDate;
        let req: any = {
            startDate,
            endDate
        }
        if (state.countryId) {
            req.countryId = state.countryId
        }
        return req;
    }
    public fetchDashboardData = async () => {
        try {
            await FxAllocationService.getFxDashboardData(this.state.accessToken, await this.getDashboardRequest(this.state)).then(response => {
                if (response.ok) {
                    response.json().then(resp => {
                        const updatedWidgets = this.state.dashboardWidget.map(widget => {
                            const trendValue = widget.trendKey ? resp[widget.trendKey as keyof typeof resp] : "";
                            let trendColor;
                            if (trendValue) {
                                trendColor = trendValue.includes("+") ? "#16a34a" : trendValue.includes("-") ? "#B50000" : "#6b7280";
                            }

                            return {
                                ...widget,
                                value: resp[widget.key],
                                trend: widget.trendKey ? resp[widget.trendKey] : '',
                                trendColor,
                                subtext: widget.subtextKey ? resp[widget.subtextKey] : '',
                            }
                        });
                        this.setState({ dashboardWidget: updatedWidgets });
                    });

                }
                else {
                    throw new Error('Failed to load data');
                }
            });
        } catch (error) {
            ShowAlert("Error", "Failed to load FX allocation data", "error");
        }
    };

    public handleNewAllocation = () => {
        const newRow: IFXPoolDetails = {
            liquidityPartnerId: 0,
            tradeDate: new Date().toISOString(),
            settlementDate: '',
            notes: '',
            usdCurrencyRate: 1.00,
            toCurrencyRate: 1.00,
            currencySpent: 'USD',
            amountSpent: 0,
            currencyObtained: '',
            targetCountryCorridor: '',
            designatedPayoutPartnerId: '',
            poolStatusId: '1',
            proofOfPurchaseLocation: '',
            fromCountryId: '',
            toCountryId: ''
        };
        this.setState({
            selectedPool: newRow,
            showPurchaseDetails: true,
            action: Actions.Create
        })
    };

    public handleFormSubmit(formData: any) {
        this.setState({
            snackbarMessage: 'New FX allocation created successfully',
            snackbarOpen: true,
            showPurchaseDetails: false
        })
        this.fetchReportData();
    };

    public handleFormCancel() {
        this.setState({
            showPurchaseDetails: false
        })
    };

    public handleViewDetails(row: IFXPoolDetails, action: Actions) {
        this.setState({
            selectedPool: row,
            showPurchaseDetails: true,
            action
        })
    };
    public async handleDeletePurchase(rowData: any) {
        try {
            const response = await FxAllocationService.deletePurchaseRecord(
                this.state.accessToken,
                rowData.poolId || rowData.pool_id
            );

            if (response.ok) {
                ShowAlert("Success", "Purchase record deleted successfully!", "success");
                this.fetchReportData();
            } else {
                const errorData = await response.json();
                ShowAlert("Error", errorData.message || "Failed to delete purchase record", "error");
            }
        } catch (error) {
            console.error("Error deleting purchase record:", error);
            ShowAlert("Error", "An unexpected error occurred while deleting the purchase record", "error");
        }
    };

    public handleSnackbarClose() {
        this.setState({
            snackbarOpen: false
        })
    };

    handleDrawerApply = (filters: { selectedId: string; startDate: string | null; endDate: string | null }) => {
        const { selectedId, startDate, endDate } = filters;

        this.setState(
            {
                countryId: selectedId || "",
                selectedDateRange: {
                    startDate: startDate || null,
                    endDate: endDate || null,
                },
                currentPage: 1,
            },
            () => {
                this.fetchReportData();
            }
        );
    };

    fetchDropdownOptions = () => {
        return fetchRecipientCountryList(this.state.accessToken);
    };

    onreferesh = () => {
        this.fetchReportData();
    }

    public render() {
        return (
            <div className="body-sub-container">
                <div className='fx-allocation-header'>
                    <h1>FX Pools Dashboard</h1>
                    <div className="fx-actions">
                        <Tooltip title="Add new pool" arrow>
                            <Button
                                color="primary"
                                style={{ minWidth: 'unset', marginLeft: "25px" }}
                                onClick={this.handleNewAllocation}
                            >
                                <AddCircleSharpIcon color="secondary" fontSize="large" />
                            </Button>
                        </Tooltip>
                        <Box
                            style={{ marginLeft: '15px', cursor: 'pointer' }}
                            onClick={() => this.setState({ isDrawerOpen: true })}
                            title="Open Filters"
                        >
                            <Badge
                                badgeContent={this.state.appliedFiltersCount}
                                color="warning"
                                invisible={this.state.appliedFiltersCount === 0}
                            >
                                <FilterAltSharpIcon fontSize="large" color="secondary" />
                            </Badge>
                        </Box>
                    </div>
                </div>
                <ReusableDrawer
                    open={this.state.isDrawerOpen}
                    onClose={() => this.setState({ isDrawerOpen: false })}
                    onApply={this.handleDrawerApply}
                    fetchDropdownOptions={this.fetchDropdownOptions}
                    defaultValue={this.state.countryId}
                    onFiltersCountChange={(count) => this.setState({ appliedFiltersCount: count })}
                    defaultStartDate={this.state.selectedDateRange.startDate}
                    defaultEndDate={this.state.selectedDateRange.endDate}
                    showDateRange={true}
                    showTxnStatusFilter={false}
                />
                <div className="overview-cards">
                    {this.state.dashboardWidget.map((item, index) => (
                        <div key={index} className="dashboard-widget">
                            <div className="dashboard-widget-icon">
                                <span className="material-symbols-outlined">{item.icon}</span>
                            </div>
                            <div className="dashboard-widget-body">
                                <div className="dashboard-widget-lable1">{item.title}</div>
                                <div className="dashboard-widget-lable2">{item.value}</div>

                                {item.trend && (
                                    <div className="dashboard-widget-trend" style={{ color: item.trendColor }}>{item.trend}</div>
                                )}
                                {item.subtext && (
                                    <div className="dashboard-widget-subtext">{item.subtext}</div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="datagrid-container">
                    <DataGrid
                        title="Pool Details"
                        search="pools"
                        //isDatePickerNeeded
                        defaultSearch={this.state.searchText}
                        columns={this.tableColumns}
                        data={this.state.data}
                        onSearch={ReportsCommon.onSearchReportWithDateFilter.bind(this)}
                        onApply={ReportsCommon.onApplyDateFilter.bind(this)}
                        onChangePage={ReportsCommon.onReportPageChange.bind(this)}
                        onChangeRowsPerPage={ReportsCommon.onReportRowPerPageChange.bind(this)}
                        pagination
                        paginationTotalRows={this.state.totalRows}
                        isClearDateOnSearch
                    />
                </div>
                <Dialog
                    open={this.state.showPurchaseDetails}
                    onClose={this.handleFormCancel}
                    maxWidth="md"
                    fullWidth
                >
                    {this.state.selectedPool && (
                        <FxPurchaseDetails
                            open={this.state.showPurchaseDetails}
                            onClose={() => this.setState({ showPurchaseDetails: false })}
                            purchaseData={this.state.selectedPool}
                            action={this.state.action}
                            refreshData={this.fetchReportData}
                        />
                    )}
                </Dialog>
            </div >
        );
    }
};

export default FxPoolsMainPage;